import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { ContentSearchData, ContentSearchEntryData } from '../uig-content-search.models';
import { UigContentSearchService } from '../uig-content-search.service';

@Component({
    selector: 'app-uig-content-search',
    templateUrl: './uig-content-search.component.html',
    styleUrls: ['./uig-content-search.component.scss'],
    standalone: false
})
export class UigContentSearchComponent implements OnInit {

  result$: Subject<ContentSearchData>;
  loading$: Subject<boolean>;
  contentSearchData: ContentSearchData;
  entries: ContentSearchEntryData[];
  suggestion: string;

  constructor(
    private route: ActivatedRoute,
    private uigContentSearchService: UigContentSearchService
  ) { }

  ngOnInit(): void {
    this.result$ = this.uigContentSearchService.getResult();
    this.loading$ = this.uigContentSearchService.getLoading();

    this.loading$.subscribe( loading => {
      if(loading) {
        this.contentSearchData = null;
        this.entries = null;
        this.suggestion = null;
      }
    });

    this.result$.subscribe(next => {
      this.contentSearchData = next;
      this.entries = next.entries;
      this.suggestion = next.suggestion;
    });
    
    this.route.url.subscribe((segments) => {
      if (segments.length == 2) {
        let query = segments[1].path;
        this.uigContentSearchService.contentSearch(query);
      }
    });
  }
}
